import videojs from 'video.js';
import AuthProvidersMenu from './auth-menu/auth-providers-menu';
import ErrorPopup from './error-popup';
import utils from './utils';
const XRegExp = require('xregexp');

const Component = videojs.getComponent('Component');

const defaultOptions = {
  isAuth: false,
  allowUnauthorized: false
};

const defaultUserData = {
  userID: null,
  name: '',
  avatarUrl: ''
};

const NAME_MAX_LENGTH = 20;
const NAME_REGEX = XRegExp('[^\\p{Letter}]+', 'ig');

export default class ChatPopup extends Component {
  constructor(player, options) {
    super(player, options);
    this.options = videojs.mergeOptions(defaultOptions, options);

    this.allowUnauthorized = this.options.allowUnauthorized;

    this.nameEl = this.el().querySelector('.vjs-chat-popup__name input');
    this.finishAuthEl = this.el().querySelector('#vjs-chat-finish-auth');
    this.finishAuthBtnEl = this.finishAuthEl.querySelector('button');
    this.authFormEl = this.el().querySelector('.vjs-chat-popup__form');

    // Элементы, в которых отображаются список социальных сетей и их попапы
    this.containerEl = this.el().querySelector('.vjs-chat-popup__container');
    this.titleFormEl = this.el().querySelector('.vjs-chat-popup__title');
    this.socialNetworksAuthEl = this.el().querySelector('.vjs-chat-popup__block-social-network');
    this.socialAuthContainerEl = this.el().querySelector('.vjs-chat-auth');
    this.socialAuthErrorEl = this.el().querySelector('.vjs-chat-auth-error');

    // Список социальных сетей
    this.authProvidersMenu = new AuthProvidersMenu(player, this.options.providers, this.containerEl, this.el().querySelector('.vjs-chat-popup__social-network'));
    this.authProvidersMenu.render();
    // Событие выбора способа авторизации
    this.authProvidersMenu.on('authProviderChoosed', (event) => this.trigger(event));

    this.errorPopup = new ErrorPopup(this);
    if (this.allowUnauthorized) {
      this.renderNameAuthForm();
    }

    this.initPopupElementsVisibility();
    this.enableDisableForm(this.options.isAuth ? 'enable' : 'disable');
    this.setListeners();
  }

  get chatApi() {
    return this.options.chatApi;
  }

  get socialNetworksUsed() {
    return this.authProvidersMenu.providers.some((el) => el != 'rdstv');
  }

  createEl() {
    const el = videojs.createEl('div', {
      className: 'vjs-chat-popup',
    });

    el.insertAdjacentHTML('afterbegin', this.getTemplate());

    return el;
  }

  initPopupElementsVisibility() {
    if (this.socialNetworksUsed) {
      this.showElement(this.socialNetworksAuthEl);
    } else {
      this.hideElement(this.socialNetworksAuthEl);
    }
  }

  showElement(el) {
    el && el.classList.remove('vjs-hidden');
  }

  hideElement(el) {
    el && el.classList.add('vjs-hidden');
  }

  setListeners() {
    this.el()
      .querySelectorAll('.vjs-chat-popup__background, .vjs-chat-popup__close')
      .forEach((el) => {
        el.addEventListener('click', () => {
          this.toggleVisibility();
        });
      });

    if (this.allowUnauthorized) {
      const startChatBtnEl = this.el().querySelector('#unauth-auth-btn button');
      const unAuthNameEl = this.el().querySelector('#unauth-username');

      unAuthNameEl.addEventListener('input', () => {
          startChatBtnEl.disabled = !this.correctName(unAuthNameEl).length;
        });

      this.el()
        .querySelector('#unauth-auth-btn')
        .addEventListener('click', () => {
          if (!this.correctName(unAuthNameEl).length) {
            return;
          }

          let userData = {
            name: this.correctName(unAuthNameEl)
          }
          this.completeAuthorization(userData);
        });
    }

    // Нажатие на кнопку "Отправить" на форме с водом имени
    this.finishAuthEl
      .addEventListener('click', () => {
        // Каким-то образом нужно уведомить пользователя, что необходимо ввести имя
        // Может делать кнопку "Отправить" недоступной для ввода?
        if (!this.correctName(this.nameEl).length) {
          return;
        }

        if (this.nameEl.value.length > NAME_MAX_LENGTH) {
          return;
        }

        this.userData.name = this.correctName(this.nameEl);
        this.trigger({
          type: 'confirmedAuthorization',
          data: {
            userData: this.userData
          }
        });
      });

    this.nameEl.addEventListener('input', () => {
      this.finishAuthBtnEl.disabled = !this.correctName(this.nameEl).length;
    });

    // Если пользователь деавторизовался, небходимо вернуть попапы для авторизации к изначальному
    // состоянию
    this.chatApi.on('deauthorized', () => {
      this.nameEl.value = '';
      this.initPopupElementsVisibility();
    });

    // Если во время авторизации через Firebase возникла ошибка, то показываем пользователю
    // сообщение об ошибке
    this.chatApi.on('sn_auth_error', () => {
      this.hideElement(this.socialAuthContainerEl);
      this.showElement(this.socialAuthErrorEl);
    });
  }

  correctName(nameEl) {
    return nameEl.value.replaceAll(NAME_REGEX, ' ').trim();
  }

  fillUserData(originalUserData) {
    let userData = videojs.mergeOptions(defaultUserData, originalUserData);
    if (!userData.userID) {
      userData.userID = (new Date() * 1).toString(32);
    }
    return userData;
  }

  /**
   * Завершение процедуры авторизации пользователя в сервиса чата после прохождение процедуры
   * авторизации в сервисе авторизации (социальная сеть, проверка почты и проч.). На данном этапе
   * пользователю необходимо ввести свое имя для отображения в чате
   *
   * @param {String} _provider - Название сервиса, через который пользователь осуществил авторизацию
   * @param {Object} userData - Данные о пользователе: URL на аватар, имя, ID в сервисе авторизации
   */
  showUserForm(provider, userData) {
    this.userData = this.fillUserData(userData);
    // Заполняем форму с именем пользователя
    this.nameEl.value = this.userData.name;
    // Отображаем форму заполнения имени
    this.showAuthForm(provider);
  }

  completeAuthorization(userData) {
    // Добавляем ID если его нет в userData
    userData = this.fillUserData(userData);
    // Авторизуем пользователя
    this.chatApi.userAuthorize(userData);
    this.chatApi.one('authorized', () => {
      this.toggleVisibility();
    });
  }

  showInstructions(provider) {
    let text = '';
    switch (provider) {
      case 'email':
        text = 'Инструкции были отправлены на указанный Вами адрес электронной почты';
        break;
      default:
        break;
    }

    const instructionsEl = this.el().querySelector('.vjs-chat-popup__instructions');
    instructionsEl.innerText = text;

    this.authProvidersMenu.hide();
    this.hideElement(this.unAuthAuthFormEl);
    this.hideElement(this.titleFormEl);
    this.hideElement(this.socialNetworksAuthEl);
    instructionsEl.classList.remove('vjs-hidden');
  }

  enableDisableForm(action) {
    if (action !== 'enable' && action !== 'disable') return;
    this.el()
      .querySelectorAll('.vjs-chat-popup__form input, .vjs-chat-popup__form button')
      .forEach((el) => {
        el.disabled = action === 'disable';
      });
  }

  /**
   * Отображение формы завершения авторизации для ввода имени пользователя в чате
   */
  showAuthForm(provider) {
    // Скрываем форму выбора социальных сетей
    this.authProvidersMenu.hidePopups();
    this.hideElement(this.socialNetworksAuthEl);
    this.hideElement(this.unAuthAuthFormEl);

    this.el().querySelector('.vjs-chat-popup__button button').innerText = 'Готово';
    this.el().classList.add('vjs-chat-popup_show');
    this.enableDisableForm('enable');
    this.finishAuthBtnEl.disabled = provider == 'email';
    this.showElement(this.authFormEl);
  }

  showError(error) {
    this.errorPopup.showError(error.message);
  }

  toggleVisibility(emitter) {
    if (emitter === 'auth') {
      this.finishAuthBtnEl.innerText = 'Готово';
      this.showElement(this.socialAuthContainerEl);
      this.hideElement(this.socialAuthErrorEl);
    }
    if (emitter === 'send') {
      this.finishAuthBtnEl.innerText = 'Отправить';
    }
    this.el().classList.toggle('vjs-chat-popup_show');
  }

  renderNameAuthForm() {
    this.unAuthAuthFormEl = videojs.createEl('div', {
      className: 'vjs-unauth-form',
    });

    this.unAuthAuthFormEl.insertAdjacentHTML('afterbegin', `
      <div class="vjs-chat-popup__name">
        <input id="unauth-username" type="text" name="" maxlength="${NAME_MAX_LENGTH}" placeholder="Введите имя...">
      </div>
      <div class="vjs-chat-popup__button" id="unauth-auth-btn">
        <button disabled>
          Начать чат
        </button>
      </div>
    `);

    this.socialAuthContainerEl.insertBefore(this.unAuthAuthFormEl, this.socialNetworksAuthEl);
  }

  getTemplate() {
    return `
      <div class="vjs-chat-popup__background"></div>
      <div class="vjs-chat-popup__container">
        <button class="vjs-chat-popup__close">
          <svg width="12" height="12" viewBox="0 0 612 670.2"><path fill="#424242" d="M345.2,335.1L603.4,44.7c9.9-9.9,9.9-27.3,0-37.2s-24.8-9.9-37.2,0L305.5,300.4L44.8,7.4C34.9-2.5,20-2.5,7.6,7.4c-9.9,9.9-9.9,27.3,0,37.2l258.2,290.5L7.6,625.6c-9.9,9.9-9.9,27.3,0,37.2s24.8,9.9,37.2,0l260.7-292.9l260.7,292.9c9.9,9.9,24.8,9.9,37.2,0c9.9-9.9,9.9-27.3,0-37.2L345.2,335.1z"></path></svg>
        </button>
        <div class="vjs-chat-auth">
          <div class="vjs-chat-popup__title">
            Авторизация
          </div>

          <div class="vjs-chat-popup__block-social-network">
            <div class="vjs-chat-popup__form-title-small">
              или войдите с помощью
            </div>
            <ul class="vjs-chat-popup__social-network">
            </ul>
          </div>

          <div class="vjs-chat-popup__instructions vjs-hidden">
          </div>

          <div class="vjs-chat-popup__form vjs-hidden">
            <div class="vjs-chat-popup__form-title">
              Ваше имя
            </div>
            <div class="vjs-chat-popup__name">
              <input disabled type="text" name="" maxlength="${NAME_MAX_LENGTH}" placeholder="Введите имя...">
            </div>
            <div class="vjs-chat-popup__button" id="vjs-chat-finish-auth">
              <button disabled>
                Отправить
              </button>
            </div>
          </div>

          <div class="vjs-chat-auth-error vjs-hidden">
            <div class="vjs-chat-popup__title">
              Ошибка авторизации
            </div>
            <div class="auth-error-message">
              Во время авторизации произошла ошибка. Попробуйте воспользоваться другим способом авторизации
            </div>
          </div>
        </div>
      </div>
    `;
  }
}

Component.registerComponent('ChatPopup', ChatPopup);
